import styled from '@emotion/styled';

export interface AiCropSizeProps {
  imageList: string[];
  setAiImageRef: (instance: Element | null) => void;
}

export const AiCropSize = ({ imageList, setAiImageRef }: AiCropSizeProps) => {
  if (!imageList.length) {
    return null;
  }
  return (
    <Container ref={setAiImageRef}>
      {imageList.map((image) => (
        <Image key={image} src={image} alt='ai-crop-size' />
      ))}
    </Container>
  );
};

const Container = styled.div`
  padding: 16px 8px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
